/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as CheckoutErrorRouteImport } from './routes/checkout/error'
import { Route as AuthVerifyEmailSentRouteImport } from './routes/auth/verify-email-sent'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthMfaVerifyRouteImport } from './routes/auth/mfa-verify'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as PortalUpgradeIndexRouteImport } from './routes/portal/upgrade/index'
import { Route as PortalSubscriptionIndexRouteImport } from './routes/portal/subscription/index'
import { Route as PortalRenewIndexRouteImport } from './routes/portal/renew/index'
import { Route as PortalPaymentsIndexRouteImport } from './routes/portal/payments/index'
import { Route as PortalInvoicesIndexRouteImport } from './routes/portal/invoices/index'
import { Route as PortalCompanyProfileIndexRouteImport } from './routes/portal/company-profile/index'
import { Route as DashboardTrialsIndexRouteImport } from './routes/dashboard/trials/index'
import { Route as DashboardSubscriptionsIndexRouteImport } from './routes/dashboard/subscriptions/index'
import { Route as DashboardRevenueDashboardIndexRouteImport } from './routes/dashboard/revenue-dashboard/index'
import { Route as DashboardProductsIndexRouteImport } from './routes/dashboard/products/index'
import { Route as DashboardPlansIndexRouteImport } from './routes/dashboard/plans/index'
import { Route as DashboardPaymentsIndexRouteImport } from './routes/dashboard/payments/index'
import { Route as DashboardMonitorIndexRouteImport } from './routes/dashboard/monitor/index'
import { Route as DashboardCustomerMessagesIndexRouteImport } from './routes/dashboard/customer-messages/index'
import { Route as DashboardAnalyticsIndexRouteImport } from './routes/dashboard/analytics/index'
import { Route as AccountUpgradeIndexRouteImport } from './routes/account/upgrade/index'
import { Route as AccountSubscriptionIndexRouteImport } from './routes/account/subscription/index'
import { Route as AccountRenewIndexRouteImport } from './routes/account/renew/index'
import { Route as AccountPaymentsIndexRouteImport } from './routes/account/payments/index'
import { Route as AccountInvoicesIndexRouteImport } from './routes/account/invoices/index'
import { Route as AccountCompanyProfileIndexRouteImport } from './routes/account/company-profile/index'
import { Route as DashboardSubscriptionsNewRouteImport } from './routes/dashboard/subscriptions/new'
import { Route as DashboardProductsNewRouteImport } from './routes/dashboard/products/new'
import { Route as DashboardPlansNewRouteImport } from './routes/dashboard/plans/new'
import { Route as DashboardSubscriptionsSubscriptionIdIndexRouteImport } from './routes/dashboard/subscriptions/$subscriptionId/index'
import { Route as DashboardProductsProductIdIndexRouteImport } from './routes/dashboard/products/$productId/index'
import { Route as DashboardPaymentsMyfatoorahIndexRouteImport } from './routes/dashboard/payments/myfatoorah/index'
import { Route as DashboardPaymentsInstapayIndexRouteImport } from './routes/dashboard/payments/instapay/index'
import { Route as DashboardPaymentsIdIndexRouteImport } from './routes/dashboard/payments/$id/index'
import { Route as DashboardAnalyticsSubscriptionEventsIndexRouteImport } from './routes/dashboard/analytics/subscription-events/index'
import { Route as DashboardAnalyticsPlatformUsageIndexRouteImport } from './routes/dashboard/analytics/platform-usage/index'

const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const CheckoutErrorRoute = CheckoutErrorRouteImport.update({
  id: '/checkout/error',
  path: '/checkout/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailSentRoute = AuthVerifyEmailSentRouteImport.update({
  id: '/verify-email-sent',
  path: '/verify-email-sent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMfaVerifyRoute = AuthMfaVerifyRouteImport.update({
  id: '/mfa-verify',
  path: '/mfa-verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const PortalUpgradeIndexRoute = PortalUpgradeIndexRouteImport.update({
  id: '/upgrade/',
  path: '/upgrade/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSubscriptionIndexRoute = PortalSubscriptionIndexRouteImport.update({
  id: '/subscription/',
  path: '/subscription/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRenewIndexRoute = PortalRenewIndexRouteImport.update({
  id: '/renew/',
  path: '/renew/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPaymentsIndexRoute = PortalPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalInvoicesIndexRoute = PortalInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCompanyProfileIndexRoute =
  PortalCompanyProfileIndexRouteImport.update({
    id: '/company-profile/',
    path: '/company-profile/',
    getParentRoute: () => PortalRoute,
  } as any)
const DashboardTrialsIndexRoute = DashboardTrialsIndexRouteImport.update({
  id: '/trials/',
  path: '/trials/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSubscriptionsIndexRoute =
  DashboardSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardRevenueDashboardIndexRoute =
  DashboardRevenueDashboardIndexRouteImport.update({
    id: '/revenue-dashboard/',
    path: '/revenue-dashboard/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardProductsIndexRoute = DashboardProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPlansIndexRoute = DashboardPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPaymentsIndexRoute = DashboardPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMonitorIndexRoute = DashboardMonitorIndexRouteImport.update({
  id: '/monitor/',
  path: '/monitor/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCustomerMessagesIndexRoute =
  DashboardCustomerMessagesIndexRouteImport.update({
    id: '/customer-messages/',
    path: '/customer-messages/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAnalyticsIndexRoute = DashboardAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => DashboardRoute,
} as any)
const AccountUpgradeIndexRoute = AccountUpgradeIndexRouteImport.update({
  id: '/upgrade/',
  path: '/upgrade/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountSubscriptionIndexRoute =
  AccountSubscriptionIndexRouteImport.update({
    id: '/subscription/',
    path: '/subscription/',
    getParentRoute: () => AccountRoute,
  } as any)
const AccountRenewIndexRoute = AccountRenewIndexRouteImport.update({
  id: '/renew/',
  path: '/renew/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountPaymentsIndexRoute = AccountPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountInvoicesIndexRoute = AccountInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountCompanyProfileIndexRoute =
  AccountCompanyProfileIndexRouteImport.update({
    id: '/company-profile/',
    path: '/company-profile/',
    getParentRoute: () => AccountRoute,
  } as any)
const DashboardSubscriptionsNewRoute =
  DashboardSubscriptionsNewRouteImport.update({
    id: '/subscriptions/new',
    path: '/subscriptions/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardProductsNewRoute = DashboardProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPlansNewRoute = DashboardPlansNewRouteImport.update({
  id: '/plans/new',
  path: '/plans/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSubscriptionsSubscriptionIdIndexRoute =
  DashboardSubscriptionsSubscriptionIdIndexRouteImport.update({
    id: '/subscriptions/$subscriptionId/',
    path: '/subscriptions/$subscriptionId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardProductsProductIdIndexRoute =
  DashboardProductsProductIdIndexRouteImport.update({
    id: '/products/$productId/',
    path: '/products/$productId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPaymentsMyfatoorahIndexRoute =
  DashboardPaymentsMyfatoorahIndexRouteImport.update({
    id: '/payments/myfatoorah/',
    path: '/payments/myfatoorah/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPaymentsInstapayIndexRoute =
  DashboardPaymentsInstapayIndexRouteImport.update({
    id: '/payments/instapay/',
    path: '/payments/instapay/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPaymentsIdIndexRoute =
  DashboardPaymentsIdIndexRouteImport.update({
    id: '/payments/$id/',
    path: '/payments/$id/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAnalyticsSubscriptionEventsIndexRoute =
  DashboardAnalyticsSubscriptionEventsIndexRouteImport.update({
    id: '/analytics/subscription-events/',
    path: '/analytics/subscription-events/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAnalyticsPlatformUsageIndexRoute =
  DashboardAnalyticsPlatformUsageIndexRouteImport.update({
    id: '/analytics/platform-usage/',
    path: '/analytics/platform-usage/',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/portal': typeof PortalRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/mfa-verify': typeof AuthMfaVerifyRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-email-sent': typeof AuthVerifyEmailSentRoute
  '/checkout/error': typeof CheckoutErrorRoute
  '/account/': typeof AccountIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/dashboard/plans/new': typeof DashboardPlansNewRoute
  '/dashboard/products/new': typeof DashboardProductsNewRoute
  '/dashboard/subscriptions/new': typeof DashboardSubscriptionsNewRoute
  '/account/company-profile/': typeof AccountCompanyProfileIndexRoute
  '/account/invoices/': typeof AccountInvoicesIndexRoute
  '/account/payments/': typeof AccountPaymentsIndexRoute
  '/account/renew/': typeof AccountRenewIndexRoute
  '/account/subscription/': typeof AccountSubscriptionIndexRoute
  '/account/upgrade/': typeof AccountUpgradeIndexRoute
  '/dashboard/analytics/': typeof DashboardAnalyticsIndexRoute
  '/dashboard/customer-messages/': typeof DashboardCustomerMessagesIndexRoute
  '/dashboard/monitor/': typeof DashboardMonitorIndexRoute
  '/dashboard/payments/': typeof DashboardPaymentsIndexRoute
  '/dashboard/plans/': typeof DashboardPlansIndexRoute
  '/dashboard/products/': typeof DashboardProductsIndexRoute
  '/dashboard/revenue-dashboard/': typeof DashboardRevenueDashboardIndexRoute
  '/dashboard/subscriptions/': typeof DashboardSubscriptionsIndexRoute
  '/dashboard/trials/': typeof DashboardTrialsIndexRoute
  '/portal/company-profile/': typeof PortalCompanyProfileIndexRoute
  '/portal/invoices/': typeof PortalInvoicesIndexRoute
  '/portal/payments/': typeof PortalPaymentsIndexRoute
  '/portal/renew/': typeof PortalRenewIndexRoute
  '/portal/subscription/': typeof PortalSubscriptionIndexRoute
  '/portal/upgrade/': typeof PortalUpgradeIndexRoute
  '/dashboard/analytics/platform-usage/': typeof DashboardAnalyticsPlatformUsageIndexRoute
  '/dashboard/analytics/subscription-events/': typeof DashboardAnalyticsSubscriptionEventsIndexRoute
  '/dashboard/payments/$id/': typeof DashboardPaymentsIdIndexRoute
  '/dashboard/payments/instapay/': typeof DashboardPaymentsInstapayIndexRoute
  '/dashboard/payments/myfatoorah/': typeof DashboardPaymentsMyfatoorahIndexRoute
  '/dashboard/products/$productId/': typeof DashboardProductsProductIdIndexRoute
  '/dashboard/subscriptions/$subscriptionId/': typeof DashboardSubscriptionsSubscriptionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/not-found': typeof NotFoundRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/mfa-verify': typeof AuthMfaVerifyRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-email-sent': typeof AuthVerifyEmailSentRoute
  '/checkout/error': typeof CheckoutErrorRoute
  '/account': typeof AccountIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/portal': typeof PortalIndexRoute
  '/dashboard/plans/new': typeof DashboardPlansNewRoute
  '/dashboard/products/new': typeof DashboardProductsNewRoute
  '/dashboard/subscriptions/new': typeof DashboardSubscriptionsNewRoute
  '/account/company-profile': typeof AccountCompanyProfileIndexRoute
  '/account/invoices': typeof AccountInvoicesIndexRoute
  '/account/payments': typeof AccountPaymentsIndexRoute
  '/account/renew': typeof AccountRenewIndexRoute
  '/account/subscription': typeof AccountSubscriptionIndexRoute
  '/account/upgrade': typeof AccountUpgradeIndexRoute
  '/dashboard/analytics': typeof DashboardAnalyticsIndexRoute
  '/dashboard/customer-messages': typeof DashboardCustomerMessagesIndexRoute
  '/dashboard/monitor': typeof DashboardMonitorIndexRoute
  '/dashboard/payments': typeof DashboardPaymentsIndexRoute
  '/dashboard/plans': typeof DashboardPlansIndexRoute
  '/dashboard/products': typeof DashboardProductsIndexRoute
  '/dashboard/revenue-dashboard': typeof DashboardRevenueDashboardIndexRoute
  '/dashboard/subscriptions': typeof DashboardSubscriptionsIndexRoute
  '/dashboard/trials': typeof DashboardTrialsIndexRoute
  '/portal/company-profile': typeof PortalCompanyProfileIndexRoute
  '/portal/invoices': typeof PortalInvoicesIndexRoute
  '/portal/payments': typeof PortalPaymentsIndexRoute
  '/portal/renew': typeof PortalRenewIndexRoute
  '/portal/subscription': typeof PortalSubscriptionIndexRoute
  '/portal/upgrade': typeof PortalUpgradeIndexRoute
  '/dashboard/analytics/platform-usage': typeof DashboardAnalyticsPlatformUsageIndexRoute
  '/dashboard/analytics/subscription-events': typeof DashboardAnalyticsSubscriptionEventsIndexRoute
  '/dashboard/payments/$id': typeof DashboardPaymentsIdIndexRoute
  '/dashboard/payments/instapay': typeof DashboardPaymentsInstapayIndexRoute
  '/dashboard/payments/myfatoorah': typeof DashboardPaymentsMyfatoorahIndexRoute
  '/dashboard/products/$productId': typeof DashboardProductsProductIdIndexRoute
  '/dashboard/subscriptions/$subscriptionId': typeof DashboardSubscriptionsSubscriptionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/portal': typeof PortalRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/mfa-verify': typeof AuthMfaVerifyRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-email-sent': typeof AuthVerifyEmailSentRoute
  '/checkout/error': typeof CheckoutErrorRoute
  '/account/': typeof AccountIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/dashboard/plans/new': typeof DashboardPlansNewRoute
  '/dashboard/products/new': typeof DashboardProductsNewRoute
  '/dashboard/subscriptions/new': typeof DashboardSubscriptionsNewRoute
  '/account/company-profile/': typeof AccountCompanyProfileIndexRoute
  '/account/invoices/': typeof AccountInvoicesIndexRoute
  '/account/payments/': typeof AccountPaymentsIndexRoute
  '/account/renew/': typeof AccountRenewIndexRoute
  '/account/subscription/': typeof AccountSubscriptionIndexRoute
  '/account/upgrade/': typeof AccountUpgradeIndexRoute
  '/dashboard/analytics/': typeof DashboardAnalyticsIndexRoute
  '/dashboard/customer-messages/': typeof DashboardCustomerMessagesIndexRoute
  '/dashboard/monitor/': typeof DashboardMonitorIndexRoute
  '/dashboard/payments/': typeof DashboardPaymentsIndexRoute
  '/dashboard/plans/': typeof DashboardPlansIndexRoute
  '/dashboard/products/': typeof DashboardProductsIndexRoute
  '/dashboard/revenue-dashboard/': typeof DashboardRevenueDashboardIndexRoute
  '/dashboard/subscriptions/': typeof DashboardSubscriptionsIndexRoute
  '/dashboard/trials/': typeof DashboardTrialsIndexRoute
  '/portal/company-profile/': typeof PortalCompanyProfileIndexRoute
  '/portal/invoices/': typeof PortalInvoicesIndexRoute
  '/portal/payments/': typeof PortalPaymentsIndexRoute
  '/portal/renew/': typeof PortalRenewIndexRoute
  '/portal/subscription/': typeof PortalSubscriptionIndexRoute
  '/portal/upgrade/': typeof PortalUpgradeIndexRoute
  '/dashboard/analytics/platform-usage/': typeof DashboardAnalyticsPlatformUsageIndexRoute
  '/dashboard/analytics/subscription-events/': typeof DashboardAnalyticsSubscriptionEventsIndexRoute
  '/dashboard/payments/$id/': typeof DashboardPaymentsIdIndexRoute
  '/dashboard/payments/instapay/': typeof DashboardPaymentsInstapayIndexRoute
  '/dashboard/payments/myfatoorah/': typeof DashboardPaymentsMyfatoorahIndexRoute
  '/dashboard/products/$productId/': typeof DashboardProductsProductIdIndexRoute
  '/dashboard/subscriptions/$subscriptionId/': typeof DashboardSubscriptionsSubscriptionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/auth'
    | '/complete-profile'
    | '/dashboard'
    | '/not-found'
    | '/portal'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/mfa-verify'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/auth/verify-email-sent'
    | '/checkout/error'
    | '/account/'
    | '/dashboard/'
    | '/portal/'
    | '/dashboard/plans/new'
    | '/dashboard/products/new'
    | '/dashboard/subscriptions/new'
    | '/account/company-profile/'
    | '/account/invoices/'
    | '/account/payments/'
    | '/account/renew/'
    | '/account/subscription/'
    | '/account/upgrade/'
    | '/dashboard/analytics/'
    | '/dashboard/customer-messages/'
    | '/dashboard/monitor/'
    | '/dashboard/payments/'
    | '/dashboard/plans/'
    | '/dashboard/products/'
    | '/dashboard/revenue-dashboard/'
    | '/dashboard/subscriptions/'
    | '/dashboard/trials/'
    | '/portal/company-profile/'
    | '/portal/invoices/'
    | '/portal/payments/'
    | '/portal/renew/'
    | '/portal/subscription/'
    | '/portal/upgrade/'
    | '/dashboard/analytics/platform-usage/'
    | '/dashboard/analytics/subscription-events/'
    | '/dashboard/payments/$id/'
    | '/dashboard/payments/instapay/'
    | '/dashboard/payments/myfatoorah/'
    | '/dashboard/products/$productId/'
    | '/dashboard/subscriptions/$subscriptionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/complete-profile'
    | '/not-found'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/mfa-verify'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/auth/verify-email-sent'
    | '/checkout/error'
    | '/account'
    | '/dashboard'
    | '/portal'
    | '/dashboard/plans/new'
    | '/dashboard/products/new'
    | '/dashboard/subscriptions/new'
    | '/account/company-profile'
    | '/account/invoices'
    | '/account/payments'
    | '/account/renew'
    | '/account/subscription'
    | '/account/upgrade'
    | '/dashboard/analytics'
    | '/dashboard/customer-messages'
    | '/dashboard/monitor'
    | '/dashboard/payments'
    | '/dashboard/plans'
    | '/dashboard/products'
    | '/dashboard/revenue-dashboard'
    | '/dashboard/subscriptions'
    | '/dashboard/trials'
    | '/portal/company-profile'
    | '/portal/invoices'
    | '/portal/payments'
    | '/portal/renew'
    | '/portal/subscription'
    | '/portal/upgrade'
    | '/dashboard/analytics/platform-usage'
    | '/dashboard/analytics/subscription-events'
    | '/dashboard/payments/$id'
    | '/dashboard/payments/instapay'
    | '/dashboard/payments/myfatoorah'
    | '/dashboard/products/$productId'
    | '/dashboard/subscriptions/$subscriptionId'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/auth'
    | '/complete-profile'
    | '/dashboard'
    | '/not-found'
    | '/portal'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/mfa-verify'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/auth/verify-email-sent'
    | '/checkout/error'
    | '/account/'
    | '/dashboard/'
    | '/portal/'
    | '/dashboard/plans/new'
    | '/dashboard/products/new'
    | '/dashboard/subscriptions/new'
    | '/account/company-profile/'
    | '/account/invoices/'
    | '/account/payments/'
    | '/account/renew/'
    | '/account/subscription/'
    | '/account/upgrade/'
    | '/dashboard/analytics/'
    | '/dashboard/customer-messages/'
    | '/dashboard/monitor/'
    | '/dashboard/payments/'
    | '/dashboard/plans/'
    | '/dashboard/products/'
    | '/dashboard/revenue-dashboard/'
    | '/dashboard/subscriptions/'
    | '/dashboard/trials/'
    | '/portal/company-profile/'
    | '/portal/invoices/'
    | '/portal/payments/'
    | '/portal/renew/'
    | '/portal/subscription/'
    | '/portal/upgrade/'
    | '/dashboard/analytics/platform-usage/'
    | '/dashboard/analytics/subscription-events/'
    | '/dashboard/payments/$id/'
    | '/dashboard/payments/instapay/'
    | '/dashboard/payments/myfatoorah/'
    | '/dashboard/products/$productId/'
    | '/dashboard/subscriptions/$subscriptionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  CompleteProfileRoute: typeof CompleteProfileRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  NotFoundRoute: typeof NotFoundRoute
  PortalRoute: typeof PortalRouteWithChildren
  CheckoutErrorRoute: typeof CheckoutErrorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/checkout/error': {
      id: '/checkout/error'
      path: '/checkout/error'
      fullPath: '/checkout/error'
      preLoaderRoute: typeof CheckoutErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email-sent': {
      id: '/auth/verify-email-sent'
      path: '/verify-email-sent'
      fullPath: '/auth/verify-email-sent'
      preLoaderRoute: typeof AuthVerifyEmailSentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/mfa-verify': {
      id: '/auth/mfa-verify'
      path: '/mfa-verify'
      fullPath: '/auth/mfa-verify'
      preLoaderRoute: typeof AuthMfaVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/portal/upgrade/': {
      id: '/portal/upgrade/'
      path: '/upgrade'
      fullPath: '/portal/upgrade/'
      preLoaderRoute: typeof PortalUpgradeIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/subscription/': {
      id: '/portal/subscription/'
      path: '/subscription'
      fullPath: '/portal/subscription/'
      preLoaderRoute: typeof PortalSubscriptionIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/renew/': {
      id: '/portal/renew/'
      path: '/renew'
      fullPath: '/portal/renew/'
      preLoaderRoute: typeof PortalRenewIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/payments/': {
      id: '/portal/payments/'
      path: '/payments'
      fullPath: '/portal/payments/'
      preLoaderRoute: typeof PortalPaymentsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/invoices/': {
      id: '/portal/invoices/'
      path: '/invoices'
      fullPath: '/portal/invoices/'
      preLoaderRoute: typeof PortalInvoicesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/company-profile/': {
      id: '/portal/company-profile/'
      path: '/company-profile'
      fullPath: '/portal/company-profile/'
      preLoaderRoute: typeof PortalCompanyProfileIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/dashboard/trials/': {
      id: '/dashboard/trials/'
      path: '/trials'
      fullPath: '/dashboard/trials/'
      preLoaderRoute: typeof DashboardTrialsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/subscriptions/': {
      id: '/dashboard/subscriptions/'
      path: '/subscriptions'
      fullPath: '/dashboard/subscriptions/'
      preLoaderRoute: typeof DashboardSubscriptionsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/revenue-dashboard/': {
      id: '/dashboard/revenue-dashboard/'
      path: '/revenue-dashboard'
      fullPath: '/dashboard/revenue-dashboard/'
      preLoaderRoute: typeof DashboardRevenueDashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/products/': {
      id: '/dashboard/products/'
      path: '/products'
      fullPath: '/dashboard/products/'
      preLoaderRoute: typeof DashboardProductsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/plans/': {
      id: '/dashboard/plans/'
      path: '/plans'
      fullPath: '/dashboard/plans/'
      preLoaderRoute: typeof DashboardPlansIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payments/': {
      id: '/dashboard/payments/'
      path: '/payments'
      fullPath: '/dashboard/payments/'
      preLoaderRoute: typeof DashboardPaymentsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/monitor/': {
      id: '/dashboard/monitor/'
      path: '/monitor'
      fullPath: '/dashboard/monitor/'
      preLoaderRoute: typeof DashboardMonitorIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/customer-messages/': {
      id: '/dashboard/customer-messages/'
      path: '/customer-messages'
      fullPath: '/dashboard/customer-messages/'
      preLoaderRoute: typeof DashboardCustomerMessagesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics/': {
      id: '/dashboard/analytics/'
      path: '/analytics'
      fullPath: '/dashboard/analytics/'
      preLoaderRoute: typeof DashboardAnalyticsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/account/upgrade/': {
      id: '/account/upgrade/'
      path: '/upgrade'
      fullPath: '/account/upgrade/'
      preLoaderRoute: typeof AccountUpgradeIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/subscription/': {
      id: '/account/subscription/'
      path: '/subscription'
      fullPath: '/account/subscription/'
      preLoaderRoute: typeof AccountSubscriptionIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/renew/': {
      id: '/account/renew/'
      path: '/renew'
      fullPath: '/account/renew/'
      preLoaderRoute: typeof AccountRenewIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/payments/': {
      id: '/account/payments/'
      path: '/payments'
      fullPath: '/account/payments/'
      preLoaderRoute: typeof AccountPaymentsIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/invoices/': {
      id: '/account/invoices/'
      path: '/invoices'
      fullPath: '/account/invoices/'
      preLoaderRoute: typeof AccountInvoicesIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/company-profile/': {
      id: '/account/company-profile/'
      path: '/company-profile'
      fullPath: '/account/company-profile/'
      preLoaderRoute: typeof AccountCompanyProfileIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/dashboard/subscriptions/new': {
      id: '/dashboard/subscriptions/new'
      path: '/subscriptions/new'
      fullPath: '/dashboard/subscriptions/new'
      preLoaderRoute: typeof DashboardSubscriptionsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/products/new': {
      id: '/dashboard/products/new'
      path: '/products/new'
      fullPath: '/dashboard/products/new'
      preLoaderRoute: typeof DashboardProductsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/plans/new': {
      id: '/dashboard/plans/new'
      path: '/plans/new'
      fullPath: '/dashboard/plans/new'
      preLoaderRoute: typeof DashboardPlansNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/subscriptions/$subscriptionId/': {
      id: '/dashboard/subscriptions/$subscriptionId/'
      path: '/subscriptions/$subscriptionId'
      fullPath: '/dashboard/subscriptions/$subscriptionId/'
      preLoaderRoute: typeof DashboardSubscriptionsSubscriptionIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/products/$productId/': {
      id: '/dashboard/products/$productId/'
      path: '/products/$productId'
      fullPath: '/dashboard/products/$productId/'
      preLoaderRoute: typeof DashboardProductsProductIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payments/myfatoorah/': {
      id: '/dashboard/payments/myfatoorah/'
      path: '/payments/myfatoorah'
      fullPath: '/dashboard/payments/myfatoorah/'
      preLoaderRoute: typeof DashboardPaymentsMyfatoorahIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payments/instapay/': {
      id: '/dashboard/payments/instapay/'
      path: '/payments/instapay'
      fullPath: '/dashboard/payments/instapay/'
      preLoaderRoute: typeof DashboardPaymentsInstapayIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payments/$id/': {
      id: '/dashboard/payments/$id/'
      path: '/payments/$id'
      fullPath: '/dashboard/payments/$id/'
      preLoaderRoute: typeof DashboardPaymentsIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics/subscription-events/': {
      id: '/dashboard/analytics/subscription-events/'
      path: '/analytics/subscription-events'
      fullPath: '/dashboard/analytics/subscription-events/'
      preLoaderRoute: typeof DashboardAnalyticsSubscriptionEventsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics/platform-usage/': {
      id: '/dashboard/analytics/platform-usage/'
      path: '/analytics/platform-usage'
      fullPath: '/dashboard/analytics/platform-usage/'
      preLoaderRoute: typeof DashboardAnalyticsPlatformUsageIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface AccountRouteChildren {
  AccountIndexRoute: typeof AccountIndexRoute
  AccountCompanyProfileIndexRoute: typeof AccountCompanyProfileIndexRoute
  AccountInvoicesIndexRoute: typeof AccountInvoicesIndexRoute
  AccountPaymentsIndexRoute: typeof AccountPaymentsIndexRoute
  AccountRenewIndexRoute: typeof AccountRenewIndexRoute
  AccountSubscriptionIndexRoute: typeof AccountSubscriptionIndexRoute
  AccountUpgradeIndexRoute: typeof AccountUpgradeIndexRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountIndexRoute: AccountIndexRoute,
  AccountCompanyProfileIndexRoute: AccountCompanyProfileIndexRoute,
  AccountInvoicesIndexRoute: AccountInvoicesIndexRoute,
  AccountPaymentsIndexRoute: AccountPaymentsIndexRoute,
  AccountRenewIndexRoute: AccountRenewIndexRoute,
  AccountSubscriptionIndexRoute: AccountSubscriptionIndexRoute,
  AccountUpgradeIndexRoute: AccountUpgradeIndexRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthMfaVerifyRoute: typeof AuthMfaVerifyRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthVerifyEmailSentRoute: typeof AuthVerifyEmailSentRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthMfaVerifyRoute: AuthMfaVerifyRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthVerifyEmailSentRoute: AuthVerifyEmailSentRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardPlansNewRoute: typeof DashboardPlansNewRoute
  DashboardProductsNewRoute: typeof DashboardProductsNewRoute
  DashboardSubscriptionsNewRoute: typeof DashboardSubscriptionsNewRoute
  DashboardAnalyticsIndexRoute: typeof DashboardAnalyticsIndexRoute
  DashboardCustomerMessagesIndexRoute: typeof DashboardCustomerMessagesIndexRoute
  DashboardMonitorIndexRoute: typeof DashboardMonitorIndexRoute
  DashboardPaymentsIndexRoute: typeof DashboardPaymentsIndexRoute
  DashboardPlansIndexRoute: typeof DashboardPlansIndexRoute
  DashboardProductsIndexRoute: typeof DashboardProductsIndexRoute
  DashboardRevenueDashboardIndexRoute: typeof DashboardRevenueDashboardIndexRoute
  DashboardSubscriptionsIndexRoute: typeof DashboardSubscriptionsIndexRoute
  DashboardTrialsIndexRoute: typeof DashboardTrialsIndexRoute
  DashboardAnalyticsPlatformUsageIndexRoute: typeof DashboardAnalyticsPlatformUsageIndexRoute
  DashboardAnalyticsSubscriptionEventsIndexRoute: typeof DashboardAnalyticsSubscriptionEventsIndexRoute
  DashboardPaymentsIdIndexRoute: typeof DashboardPaymentsIdIndexRoute
  DashboardPaymentsInstapayIndexRoute: typeof DashboardPaymentsInstapayIndexRoute
  DashboardPaymentsMyfatoorahIndexRoute: typeof DashboardPaymentsMyfatoorahIndexRoute
  DashboardProductsProductIdIndexRoute: typeof DashboardProductsProductIdIndexRoute
  DashboardSubscriptionsSubscriptionIdIndexRoute: typeof DashboardSubscriptionsSubscriptionIdIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardPlansNewRoute: DashboardPlansNewRoute,
  DashboardProductsNewRoute: DashboardProductsNewRoute,
  DashboardSubscriptionsNewRoute: DashboardSubscriptionsNewRoute,
  DashboardAnalyticsIndexRoute: DashboardAnalyticsIndexRoute,
  DashboardCustomerMessagesIndexRoute: DashboardCustomerMessagesIndexRoute,
  DashboardMonitorIndexRoute: DashboardMonitorIndexRoute,
  DashboardPaymentsIndexRoute: DashboardPaymentsIndexRoute,
  DashboardPlansIndexRoute: DashboardPlansIndexRoute,
  DashboardProductsIndexRoute: DashboardProductsIndexRoute,
  DashboardRevenueDashboardIndexRoute: DashboardRevenueDashboardIndexRoute,
  DashboardSubscriptionsIndexRoute: DashboardSubscriptionsIndexRoute,
  DashboardTrialsIndexRoute: DashboardTrialsIndexRoute,
  DashboardAnalyticsPlatformUsageIndexRoute:
    DashboardAnalyticsPlatformUsageIndexRoute,
  DashboardAnalyticsSubscriptionEventsIndexRoute:
    DashboardAnalyticsSubscriptionEventsIndexRoute,
  DashboardPaymentsIdIndexRoute: DashboardPaymentsIdIndexRoute,
  DashboardPaymentsInstapayIndexRoute: DashboardPaymentsInstapayIndexRoute,
  DashboardPaymentsMyfatoorahIndexRoute: DashboardPaymentsMyfatoorahIndexRoute,
  DashboardProductsProductIdIndexRoute: DashboardProductsProductIdIndexRoute,
  DashboardSubscriptionsSubscriptionIdIndexRoute:
    DashboardSubscriptionsSubscriptionIdIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface PortalRouteChildren {
  PortalIndexRoute: typeof PortalIndexRoute
  PortalCompanyProfileIndexRoute: typeof PortalCompanyProfileIndexRoute
  PortalInvoicesIndexRoute: typeof PortalInvoicesIndexRoute
  PortalPaymentsIndexRoute: typeof PortalPaymentsIndexRoute
  PortalRenewIndexRoute: typeof PortalRenewIndexRoute
  PortalSubscriptionIndexRoute: typeof PortalSubscriptionIndexRoute
  PortalUpgradeIndexRoute: typeof PortalUpgradeIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalIndexRoute: PortalIndexRoute,
  PortalCompanyProfileIndexRoute: PortalCompanyProfileIndexRoute,
  PortalInvoicesIndexRoute: PortalInvoicesIndexRoute,
  PortalPaymentsIndexRoute: PortalPaymentsIndexRoute,
  PortalRenewIndexRoute: PortalRenewIndexRoute,
  PortalSubscriptionIndexRoute: PortalSubscriptionIndexRoute,
  PortalUpgradeIndexRoute: PortalUpgradeIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  CompleteProfileRoute: CompleteProfileRoute,
  DashboardRoute: DashboardRouteWithChildren,
  NotFoundRoute: NotFoundRoute,
  PortalRoute: PortalRouteWithChildren,
  CheckoutErrorRoute: CheckoutErrorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
